import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import * as actions from '../actions';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';

const REQUEST_CURRENCIES = 'requestCurrencies';

export function requestCurrencies(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.FETCH_CURRENCIES,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url: GENERAL_FUNCTIONS.getBaseURL() + 'api/currency',
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_CURRENCIES,
            method: 'GET',
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_CURRENCIES)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchCurrenciesSuccess(response)
                : actions.fetchCurrenciesFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}
